<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-text class="black--text">
        <div class="font-weight-bold headline">Daftar Konfirmasi Kesediaan</div>
        <div>Silakan lakukan konfirmasi kesediaan Anda untuk mengisi kelas diklat</div>

        <div class="mt-5">
          <v-row v-if="$vuetify.breakpoint.mdAndUp">
            <v-col cols="12" md="3" sm="12">
              <span class="font-weight-medium">Nama Instansi</span>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <span class="font-weight-medium">Nama Kelas</span>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <span class="font-weight-medium">Jadwal Pelaksanaan</span>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <span class="font-weight-medium">Status</span>
            </v-col>
          </v-row>
          <v-row v-for="(item, i) in items" :key="i">
            <v-col class="py-0" cols="12" md="3">
              <v-list-item class="px-0">
                <v-list-item-content class="pa-0">
                  <div>
                    {{
                      $getAttr(
                        $getIncluded(
                          `instansi`,
                          $getAttr(
                            $getIncluded(
                              `paud_diklat${label}`,
                              $getAttr(item, `paud_diklat${label}_id`) ||
                                $getAttr(
                                  $getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)),
                                  'paud_diklat_bcmp_id'
                                )
                            ),
                            'instansi_id'
                          )
                        ),
                        'nama'
                      )
                    }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="py-0" cols="12" md="3">
              <v-list-item class="px-0">
                <v-list-item-content class="pa-0">
                  <div class="black--text">
                    {{
                      $getAttr(item, 'nama') ||
                      $getAttr($getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)), 'nama') ||
                      '-'
                    }}
                  </div>

                  <div
                    v-if="
                      $getAttr(
                        $getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)),
                        'url_jadwal'
                      )
                    "
                    class="blue--text caption"
                  >
                    <v-icon left small>mdi-file</v-icon>
                    <a
                      class="blue--text"
                      :href="
                        $getAttr(
                          $getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)),
                          'url_jadwal'
                        )
                      "
                      target="_blank"
                      >Dokumen Jadwal Diklat</a
                    >
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="py-0" cols="12" md="2">
              <v-list-item class="px-0">
                <v-list-item-content class="pa-0">
                  <div v-if="jenis === 'daring'">
                    {{
                      $durasi(
                        $getAttr(
                          $getIncluded(
                            `paud_periode`,
                            $getAttr($getIncluded('paud_diklat', $getAttr(item, 'paud_diklat_id')), 'paud_periode_id')
                          ),
                          'tgl_diklat_mulai'
                        ),
                        $getAttr(
                          $getIncluded(
                            `paud_periode`,
                            $getAttr($getIncluded('paud_diklat', $getAttr(item, 'paud_diklat_id')), 'paud_periode_id')
                          ),
                          'tgl_diklat_selesai'
                        )
                      )
                    }}
                  </div>
                  <div v-else>
                    {{
                      $durasi(
                        $getAttr(
                          $getIncluded(
                            `paud_diklat${label}`,
                            $getAttr(item, `paud_diklat${label}_id`) ||
                              $getAttr(
                                $getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)),
                                'paud_diklat_bcmp_id'
                              )
                          ),
                          'tgl_mulai'
                        ),
                        $getAttr(
                          $getIncluded(
                            `paud_diklat${label}`,
                            $getAttr(item, `paud_diklat${label}_id`) ||
                              $getAttr(
                                $getIncluded(`paud_kelas${label}`, $getAttr(item, `paud_kelas${label}_id`)),
                                'paud_diklat_bcmp_id'
                              )
                          ),
                          'tgl_selesai'
                        )
                      )
                    }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="py-0" cols="12" md="2">
              <v-list-item class="px-0">
                <v-list-item-content class="pa-0">
                  <span
                    :class="
                      Number($getAttr(item, 'k_konfirmasi_paud')) === 3
                        ? 'success--text'
                        : Number($getAttr(item, 'k_konfirmasi_paud')) === 4
                        ? 'red--text'
                        : 'grey--text'
                    "
                  >
                    <i>
                      {{
                        $getAttr($getIncluded('m_konfirmasi_paud', $getAttr(item, 'k_konfirmasi_paud')), 'keterangan')
                      }}
                    </i>
                  </span>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="py-0" cols="12" md="2">
              <v-list-item class="pa-0">
                <v-list-item-content>
                  <div>
                    <v-btn
                      color="orange"
                      block
                      depressed
                      dark
                      small
                      :outlined="+Number($getAttr(item, 'k_konfirmasi_paud')) !== 2"
                      @click="onDetail(item)"
                    >
                      {{ Number($getAttr(item, 'k_konfirmasi_paud')) === 2 ? 'Konfirmasi' : 'Detail' }}
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="800" persistent transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="secondary">
            <v-toolbar-title>Konfirmasi Kesediaan</v-toolbar-title>
            <v-spacer />
            <v-btn right icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pb-0 black--text my-5">
          <v-card outlined flat>
            <v-card-title>
              <v-toolbar flat>
                <div class="font-weight-medium body-1">
                  {{ $getDeepObj(diklat, `paud_kelas${label}.data.paud_diklat${label}.data.nama`) || '-' }} -
                  {{ $getDeepObj(diklat, `paud_kelas${label}.data.nama`) || '-' }}<br />
                  <span class="body-2">
                    {{
                      $getDeepObj(
                        diklat,
                        `paud_kelas${label}.data.paud_diklat${label}.data.paud_instansi.data.instansi.data.nama`
                      ) || ''
                    }}
                  </span>
                </div>
                <v-spacer></v-spacer>
                <v-chip
                  :color="+diklat.k_konfirmasi_paud === 3 ? 'success' : +diklat.k_konfirmasi_paud === 4 ? 'red' : ''"
                  small
                  dark
                >
                  {{ $getDeepObj(diklat, 'm_konfirmasi_paud.data.keterangan') }}
                </v-chip>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-list-item>
                    <v-list-item-avatar color="primary">
                      <v-icon dark>mdi-calendar-clock</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 mt-3">
                      <div class="label--text">Jadwal Diklat</div>
                      <div class="body-1 black--text">
                        <template v-if="jenis === 'daring'">
                          {{
                            $durasi(
                              $getDeepObj(
                                diklat,
                                'paud_kelas.data.paud_diklat.data.paud_periode.data.tgl_diklat_mulai'
                              ),
                              $getDeepObj(
                                diklat,
                                'paud_kelas.data.paud_diklat.data.paud_periode.data.tgl_diklat_selesai'
                              )
                            )
                          }}
                        </template>
                        <template v-else-if="jenis === 'luring'">
                          {{
                            $durasi(
                              $getDeepObj(diklat, 'paud_kelas_luring.data.paud_diklat_luring.data.tgl_mulai'),
                              $getDeepObj(diklat, 'paud_kelas_luring.data.paud_diklat_luring.data.tgl_selesai')
                            )
                          }}
                        </template>
                        <template v-else-if="jenis === 'bcmp'">
                          {{
                            $durasi(
                              $getDeepObj(diklat, 'paud_kelas_bcmp.data.paud_diklat_bcmp.data.tgl_mulai'),
                              $getDeepObj(diklat, 'paud_kelas_bcmp.data.paud_diklat_bcmp.data.tgl_selesai')
                            )
                          }}
                        </template>
                        <template v-else>
                          {{
                            $durasi(
                              $getDeepObj(diklat, 'paud_kelas_refreshment.data.paud_diklat_refreshment.data.tgl_mulai'),
                              $getDeepObj(
                                diklat,
                                'paud_kelas_refreshment.data.paud_diklat_refreshment.data.tgl_selesai'
                              )
                            )
                          }}
                        </template>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-avatar color="primary">
                      <v-icon dark>mdi-map-check</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 mt-3">
                      <div class="label--text">Kota/Kab</div>
                      <div class="body-1 black--text">
                        {{
                          $getDeepObj(
                            diklat,
                            `paud_kelas${label}.data.paud_diklat${label}.data.m_kota.data.keterangan`
                          ) || '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-content class="py-0 mt-3">
                      <div class="label--text">Kecamatan</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(diklat, `paud_kelas${label}.data.m_kecamatan.data.keterangan`) || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-content class="py-0 mt-3">
                      <div class="label--text">Kelurahan</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(diklat, `paud_kelas${label}.data.m_kelurahan.data.keterangan`) || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col v-if="$getDeepObj(diklat, 'k_matalatih_paud_1')" cols="12" sm="12" md="12">
                  <v-list-item>
                    <v-list-item-avatar color="primary">
                      <v-icon dark>mdi-school</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0">
                      <div class="">
                        Mata Latih 1:
                        <span class="black--text">
                          {{ $getDeepObj(masters, `${$getDeepObj(diklat, 'k_matalatih_paud_1')}`) }}</span
                        >
                      </div>
                      <div v-if="$getDeepObj(diklat, 'k_matalatih_paud_2')" class="">
                        Mata Latih 2:
                        <span class="black--text">
                          {{ $getDeepObj(masters, `${$getDeepObj(diklat, 'k_matalatih_paud_2')}`) }}</span
                        >
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div>
            Apakan Anda bersedia berpartisipasi dalam program diklat gtk paud sebagai
            <b>{{ $getDeepObj(diklat, 'm_petugas_paud.data.keterangan') }}</b>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-right">
            <template v-if="+diklat.k_konfirmasi_paud === 2">
              <v-btn color="red" dark depressed @click="onKonfirmasi('tidak-setuju')">Tidak Bersedia</v-btn>
              <v-btn class="mx-md-1" color="success" dark depressed @click="onKonfirmasi('setuju')">Bersedia</v-btn>
            </template>
            <template v-else-if="+diklat.k_konfirmasi_paud !== 1">
              <v-btn color="red" dark depressed @click="onKonfirmasi('reset')">
                <v-icon left>mdi-close</v-icon>
                Batalkan
              </v-btn>
            </template>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="latih" max-width="600" persistent transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="secondary">
            <v-toolbar-title>Bersedia BCMP</v-toolbar-title>
            <v-spacer />
            <v-btn right icon dark @click="latih = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pb-0 black--text pa-8">
          Anda telah menyelesaikan
          <b>
            {{ $getDeepObj(diklat, 'paud_petugas.data.paud_petugas_diklats.data.0.m_diklat_paud.data.keterangan') }}
            &nbsp;
            {{
              $getDeepObj(diklat, 'paud_petugas.data.paud_petugas_diklats.data.0.m_tingkat_diklat_paud.data.keterangan')
            }} </b
          >, Silakan Pilih {{ isMultiMataLatih ? 2 : 1 }} Mata latih untuk mengikuti Diklat Bimtek Calon Mater Pelatih
          <div class="label--text body-1 mt-3">Mata Latih 1</div>
          <v-select
            v-model="form.k_matalatih_paud_1"
            outlined
            dense
            placeholder="Mata Latih 1"
            :items="$mapForMaster(masters)"
            item-text="text"
            item-value="value"
          />
          <template v-if="isMultiMataLatih">
            <div class="label--text body-1">Mata Latih 2</div>
            <v-select
              v-model="form.k_matalatih_paud_2"
              outlined
              dense
              placeholder="Mata Latih 1"
              :items="$mapForMaster(masters)"
              item-text="text"
              item-value="value"
            />
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn text @click="latih = false">Batal</v-btn>
            <v-btn class="mx-md-1" color="primary" dark depressed @click="onKonfirmasiLatih('setuju')">Simpan</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    jenis: {
      type: String,
      default: 'daring',
    },
    included: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      latih: false,
      masters: {},
      diklat: {},
      form: {},
    };
  },
  computed: {
    label() {
      const keys = {
        daring: '',
        luring: '_luring',
        refreshment_petugas: '_refreshment',
        refreshment_peserta: '_refreshment',
      };
      return keys[this.jenis] || '_bcmp';
    },
    isMultiMataLatih() {
      return (
        Number(
          this.$getDeepObj(this, 'diklat.paud_petugas.data.paud_petugas_diklats.data.0.k_tingkat_diklat_paud') || 1
        ) >= 2
      );
    },
  },
  methods: {
    ...mapActions('petugasKonfirmasi', ['getDetail', 'actions', 'getLatih']),

    close() {
      this.dialog = false;
    },

    async onDetail(data) {
      const resp = await this.getDetail({ id: this.$getDeepObj(data, 'id') }).then(({ data }) => data);
      if (this.jenis === 'bcmp_peserta') {
        this.masters = {};
        const master = await this.getLatih(data.id).then(({ data }) => data);
        Object.keys(master).forEach((key) => {
          this.$set(
            this.masters,
            this.$getDeepObj(master, `${key}.id`),
            this.$getDeepObj(master, `${key}.attributes.keterangan`)
          );
        });
      }
      this.dialog = true;
      this.$nextTick(() => {
        this.$set(this, 'diklat', resp);
      });
    },

    onKonfirmasi(status) {
      if (this.jenis === 'bcmp_peserta' && status === 'setuju') {
        this.dialog = false;
        this.latih = true;
        return;
      } else {
        this.actions({
          id: this.$getDeepObj(this.diklat, 'id'),
          name: status,
          api: ['_bcmp', '_refreshment'].includes(this.label) ? 'post' : 'get',
        }).then(() => {
          this.$success('Aksi berhasil dijalankan');
          this.dialog = false;
          this.$emit('reload');
        });
      }
    },

    onKonfirmasiLatih(status) {
      if (!this.$getDeepObj(this.form, 'k_matalatih_paud_1')) {
        this.$error('Harap pilih mata latih 1');
        return;
      } else if (!this.$getDeepObj(this.form, 'k_matalatih_paud_2') && this.isMultiMataLatih) {
        this.$error('Harap pilih mata latih 2');
        return;
      } else {
        this.actions({ id: this.$getDeepObj(this.diklat, 'id'), name: status, api: 'post', params: this.form }).then(
          () => {
            this.$success('Aksi berhasil dijalankan');
            this.latih = false;
            this.$emit('reload');
          }
        );
      }
    },
  },
};
</script>
